import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { CheckboxGroupFieldWUT } from '../../../ui/checkbox-group-field';
export const CheckboxGroupWUT = props => {
  const {
    fieldType = FIELD_TYPES.CHECKBOX_GROUP
  } = props;
  return /*#__PURE__*/React.createElement(CheckboxGroupFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=checkbox-group-wut.js.map